export const api = {
    version:'1.1.26',

    // Production
    url: 'https://api-customers.groupbenefitz.net/api/ep',
    adminApiUrl: 'https://api-admin.groupbenefitz.net',
    reportApiUrl: 'https://reportsapi.groupbenefitz.net',
    commonLoginApiUrl: 'https://api-common.groupbenefitz.net/api/cr/',
    authorizeApiUrl: 'https://services.igbms.com/',
    authorizeNet: true, // make it to true after setup for new apis subscription and registration have handled
    clientKey: '34LwFKk53macuZ5AHk3HFr24rM38ZkvcwxPV558R5s9ZhLm68rVdLxXhre3U2Jua',
    apiLoginID: '3J47gF32ve',
    acceptJsUrl:"https://js.authorize.net/v1/Accept.js",
    lang: 'https://languageengineapi.groupbenefitz.net/',
    signIn: 'https://api.groupbenefitz.ca/api/',

    fileSize: sessionStorage.getItem("fileSize"),
}

